import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f48cf08e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "report"
}
const _hoisted_2 = { class: "container maxWidth-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-thick hr-magazine-left hr-magazine-short" }, null, -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Top 2 Best-fit Leader types", -1))
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Bottom 2 Least-fit Leader types", -1))
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_13 = {
  class: "row",
  style: {"margin-top":"3rem"}
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Cannot create a report for this organisation", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Loading...", -1))
const _hoisted_19 = [
  _hoisted_18
]

import { ref, computed, onMounted } from "vue";
import axios from "axios";
import { OrganisationReportApiModel, StrengthItemRatingApiModel } from "../../api-models";
import DonutChart from "../../components/admin/report-templates/donut-chart.vue";
import StrengthsListPair from "../../components/strengths-lists/strengths-list-pair.vue";
import OrganisationHeads from "../../components/admin/organisation/organisation-heads.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'organisation-report',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const report = ref<OrganisationReportApiModel | null>(null);
const error = ref(false);

const sortedSolos = computed(() => {
  return (
    report.value?.organisationSoloReport?.strengths
      .slice()
      .sort((a, b) => (a.zScore != null && b.zScore != null ? b.zScore - a.zScore : 0)) ?? []
  );
});

const sortedViewpoints = computed((): StrengthItemRatingApiModel[] => {
  return (
    report.value?.organisationViewpointsReport?.strengths
      .slice()
      .sort((a, b) => (a.zScore != null && b.zScore != null ? b.zScore - a.zScore : 0)) ?? []
  );
});

onMounted(async () => {
  axios
    .get(`/api/organisationreport/${props.id}`)
    .then((resp) => {
      report.value = resp.data;
    })
    .catch(() => {
      error.value = true;
    });
});

return (_ctx: any,_cache: any) => {
  return (report.value !== null && report.value != undefined && report.value.membersWithSoloCount > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, "Organisation Report for " + _toDisplayString(report.value.name), 1),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(OrganisationHeads, {
            id: _ctx.id,
            hasViewpoints: report.value.membersWithViewpointsCount > 1
          }, null, 8, ["id", "hasViewpoints"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(DonutChart, {
              title: "Solo",
              membersCount: report.value.membersWithSoloCount,
              description: "Percentage of best fit leader types in the\r\n    organisation based on solo",
              values: report.value.organisationSoloReport.bestFitLeadersDistribution,
              leaderTypeDetails: report.value.leaderTypes
            }, null, 8, ["membersCount", "values", "leaderTypeDetails"])
          ]),
          (report.value.membersWithViewpointsCount > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(DonutChart, {
                  title: "Viewpoints",
                  membersCount: report.value.membersWithViewpointsCount,
                  description: "Percentage of best fit leader types in the\r\n    organisation based on viewpoints",
                  values: report.value.organisationViewpointsReport.bestFitLeadersDistribution,
                  leaderTypeDetails: report.value.leaderTypes
                }, null, 8, ["membersCount", "values", "leaderTypeDetails"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(DonutChart, {
              title: "Solo",
              membersCount: report.value.membersWithSoloCount,
              description: "Percentage of best fit leader types in the\r\n    organisation based on solo",
              values: report.value.organisationSoloReport.worstFitLeadersDistribution,
              leaderTypeDetails: report.value.leaderTypes
            }, null, 8, ["membersCount", "values", "leaderTypeDetails"])
          ]),
          (report.value.membersWithViewpointsCount > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(DonutChart, {
                  title: "Viewpoints",
                  membersCount: report.value.membersWithViewpointsCount,
                  description: "Percentage of best fit leader types in the\r\n    organisation based on viewpoints",
                  values: report.value.organisationViewpointsReport.worstFitLeadersDistribution,
                  leaderTypeDetails: report.value.leaderTypes
                }, null, 8, ["membersCount", "values", "leaderTypeDetails"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(StrengthsListPair, {
            soloRatings: sortedSolos.value,
            viewpointsRatings: sortedViewpoints.value
          }, null, 8, ["soloRatings", "viewpointsRatings"])
        ])
      ]))
    : (
      error.value || (report.value !== null && report.value != undefined && report.value.membersWithSoloCount <= 1)
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
}
}

})